import React, { useMemo } from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import CommonLoader from "../../../common/CommonLoader/CommonLoader";
import { useDepartments } from "../../../../hooks/api/education/useAcademicStructure";
import { formatEntityStatus } from "../common/academicUtils";

const DepartmentDetail: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const { departmentId = "" } = useParams();
  const { data: departments = [], isPending } = useDepartments();

  const department = useMemo(
    () => departments.find((item) => item.id === departmentId),
    [departments, departmentId]
  );

  if (isPending) {
    return (
      <CommonLoader
        loadingMessage={t("loading-department", "Loading department...")}
      />
    );
  }

  if (!department) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>
          {t("department-not-found", "Department not found.")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box data-testid="department-detail-page" sx={{ p: 3 }}>
      <Link component={RouterLink} to="..">
        {t("back-to-departments", "Back to departments")}
      </Link>

      <Typography variant="h5" component="h1" sx={{ mt: 2, mb: 0.5 }}>
        {department.name}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        {formatEntityStatus(department.status)}
      </Typography>

      {department.description ? (
        <Typography variant="body2">{department.description}</Typography>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t("no-description", "No description.")}
        </Typography>
      )}
    </Box>
  );
};

export default DepartmentDetail;
